<div [ngClass]="{'m-t m-t-3-s bg-col-51-x bg-col-51-l p-a-10 p-a-0-s': !rightView}">
    @if (iconsSections?.length) {
    <div class="m-t m-b"
         [grid]="4"
         [gridColumnGap]="'12px'">
        @for (item of iconsSections; track $index) {
        <div class="center flex-column flex-middle gap-12"
             [gridColumn]="1">
            <div class="ratio-1-1"
                 [style.width.px]="62">
                <img class="fill"
                     [image]="item.image" />
            </div>
            <div class="w-12">
                <p class="s2">
                    <span [innerHTML]="item.attribute.label"></span>:
                </p>
                <p class="p2">
                    <span [innerHTML]="item.attribute.valuesLabels"></span><span>@if(item.attribute.code != 'weight' && item.attribute.code != 'webweight'){cm}@if(item.attribute.code == 'weight' || item.attribute.code == 'webweight'){kg}</span>
                </p>
            </div>
        </div>
        }
    </div>
    }
    <div class="flex flex-justify-between m-t-4-s">
        @for (attribute of displayedTopAttributes; track attribute) {
        <div [ngClass]="{'p-b-6 p-b-0-s p-t-6-s' : rightView}">
            <span class="p2">
                @if (!isPDF(attribute.valuesLabels[0])) {
                <span [innerHTML]="attribute.valuesLabels"></span>
                }
                @if (isPDF(attribute.valuesLabels[0])) {
                <href [hrefTarget]="'_blank'"
                      [link]="attribute.valuesLabels[0]">{{'Download' | translate }}</href>
                }
                @if (attribute.code == 'width' || attribute.code == 'depth' || attribute.code == 'height') {
                <span>{{'cm'
                    | translate}}</span>
                }
            </span>
        </div>
        }
    </div>
    <div class="m-r-0-s m-t-4-s m-b-5 m-b-0-m m-b-0-s">
        @for (item of dimensionsSections; track item; let i = $index) {
        <div class="m-b-5-x m-b-5-l">
            <div class="p-b p-t b-b b-col-4 cursor-pointer flex flex-justify-between flex-middle"
                 [zippyToggle]="zippyNamePrefix + i">
                <span class="h4"
                      [innerHTML]="item.title"></span>
                <i class="p-r-1 p-t-2"
                   [zippyName]="zippyNamePrefix + i"
                   zippyClass="flip"
                   class="indicator icon-chevron-up m-r-1"></i>
            </div>
            <div class="hide-up-container">
                <div class="ng-hide-animate hide-up _hide-up-200"
                     [zippy]="zippyNamePrefix + i"
                     [zippyState]="true">
                    @for (attribute of item.attributes; track attribute) {
                    <div class="p-t p-b p-t-3-m p-b-3-m p-t-3-s p-b-3-s b-b b-col-4"
                         [ngClass]="{'p-t-3 p-b-3' : rightView}">
                        <p class="c-5 m-r-0-x m-r-0-l m-b-0 p-r"
                           sizeClass="SM:s2, XL:s1"
                           [innerHTML]="attribute.label"></p>
                        <p class="c-7 m-r-0 m-b-0"
                           sizeClass="SM:p2, XL:p1">
                            @if (!isPDF(attribute.valuesLabels[0])) {
                            <span [innerHTML]="attribute.valuesLabels"></span>
                            }
                            @if (isPDF(attribute.valuesLabels[0])) {
                            <href [hrefTarget]="'_blank'"
                                  [link]="attribute.valuesLabels[0]">{{'Download' | translate }}</href>
                            }
                            @if (attribute.code == 'width' || attribute.code == 'depth' || attribute.code == 'height') {
                            <span>{{'cm'
                                | translate}}</span>
                            }
                        </p>
                    </div>
                    }
                </div>
            </div>
        </div>
        }
    </div>
</div>